import React from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'
import Radio from '../common/RadioButton/RadioButtonDetail'

const RadioButtonDetail = ({ form, field, onChange, disabled, ...props }) => (
  <Radio
    inputProps={{
      error: getIn(form.touched, field.name) && getIn(form.errors, field.name),
      helperText:
        getIn(form.touched, field.name) && getIn(form.errors, field.name),
    }}
    {...field}
    onChange={(newValue) => {
      form.setFieldValue(field.name, newValue)
      onChange(newValue)
    }}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

RadioButtonDetail.defaultProps = {
  onChange: () => {},
  disabled: false,
}

RadioButtonDetail.propTypes = {
  onChange: PropTypes.func,
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
}

export default RadioButtonDetail
